import { Components } from '@mui/material/styles/components'

export const select: Components['MuiNativeSelect'] = {
  styleOverrides: {
    root: {
      padding: '0',
    },
  },
}
